import { gql } from 'graphql-request';

export const GET_SESSION_DETAILS = gql`
  query ($id: ID!) {
    casting_session(id: $id) {
      id
      allow_walk_in
      required_signed_nda
      nda_content
    }
  }
`;
